/**
 * `#cta` — `template.html` dòng 1041–1052.
 *
 * KHÔNG có khoá `href`: cả hai nút dùng hằng `#cta` ngay trong JSX, giống `Header`, `MobileDrawer`
 * và `HeroSection`. Một hằng giống hệt nhau ở mọi ngôn ngữ mà đi qua copy chỉ tạo thêm một chỗ để
 * lệch. (User chốt 2026-08-20: tạm giữ `href="#cta"` cho tới khi có trang đích thật.)
 *
 * Hai nhãn nút này TRÙNG với `common.nav.cta` và `hero.ctaPrimary`/`ctaSecondary` — cố ý, theo
 * design doc §12.3: mỗi lô sở hữu copy của mình và ba bề mặt đổi nhãn độc lập được (header rút gọn
 * được cho vừa bar, `#cta` thì không). Đếm toàn bản thiết kế: "Dùng thử miễn phí" 3 lượt,
 * "Đặt lịch demo" 4 lượt — nên đổi wording là sửa nhiều chỗ, không phải một.
 */
export const cta = {
  heading: 'Xem Nexa chạy trên đúng quy trình của bạn.',
  lead: 'Bắt đầu dùng thử miễn phí, hoặc đặt lịch demo 30 phút cùng đội NewEra Inc.',
  primary: 'Dùng thử miễn phí',
  secondary: 'Đặt lịch demo',
  /** Wordmark "Reimagined" — KHÔNG dịch, nó là chữ thương hiệu (`template.html:1050`). */
  wordmark: 'Reimagined',
};
